// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Czak","content":"RecentSearches_content__3Wmgd"};